const sizeGuideButton = document.getElementById("sizeguide_button")
const sizeGuideImage = document.getElementById("sizeguide_image")
const sizeGuidePopup = document.getElementById("sizeguide_popup")

// Get the image URL from the block settings
sizeGuideImage.src = sizeGuideButton.dataset.imageUrl

// Install event listeners
sizeGuideButton.addEventListener("click", showSizeGuide)
sizeGuidePopup.addEventListener("click", hideSizeGuide)

function showSizeGuide() {
  sizeGuidePopup.classList.remove("hidden");
}

function hideSizeGuide({ target }) {
  if (sizeGuideImage.contains(target)) return
  sizeGuidePopup.classList.add("hidden")
}